module.exports = __webpack_public_path__ + "741880c397e2eee1401399f634cc2502.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/RoundedMplus1c-Black.ttf
// module id = 28
// module chunks = 0